export default {"src":"/_next/static/media/comment.23722ee8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};